<template>
    <div class="parkinglot_map">
        <loading v-if="loading"/>
        <!-- 找停車場_map -->
        <section class="parkinglot-section" v-if="lots.length"> 
            <div class="row parkinglot-map-title">
                <div class="col-lg-12 text-center">
                  <h2 class="section-heading text-uppercase">Parking Lots</h2>
                  <h3 class="section-subheading text-muted parkinglot-subheading">找停車場</h3>
                  <div class="parkinglot-switch-box">
                    <router-link :to="'parkinglot_lists'"><div class="parkinglot-switch fl">列表顯示</div></router-link>
                    <router-link :to="'parkinglot_map'"><div class="parkinglot-switch fl">地圖顯示</div></router-link>
                    <div class="cb"></div>
                  </div>
                
                </div>
            </div>
            <GmapMap
                :center="{lat:lots[currentIndex].latitude, lng:lots[currentIndex].longitude}"
                :zoom="17"
                :style="'height: ' + windowHeight + 'px'"
                class="map"
                ref="mapRef"
            >
                <GmapMarker
                    :key="lot.id"
                    v-for="lot in lots"
                    :position="lot.position"
                />
            </GmapMap>

            <div class="parkinglot-map-card-box" :style="'top: calc(' + windowHeight + 'px - 228px)'" v-if="swiperOption.slidesPerView">      
                <swiper  ref="lotsSwiper" :options="swiperOption">
                    <!-- slides -->
                    <swiper-slide v-for="lot in lots" :key="lot.id">
                        <router-link :to="'parkinglot_view?id=' + lot.id">
                            <div class="parkinglot-card parkinglot-map-card">

                                <div class="parkinglot-open fl" v-if="lot.open"><i class="fas fa-circle"></i>OPEN</div>
                                <div class="parkinglot-closed fl" v-if="!lot.open"><i class="fas fa-ban"></i>CLOSED</div>
                                <div class="parkinglot-distance fr" v-on:click="navigation(lot.latitude, lot.longitude)" v-if="lot.distance"><i class="fas fa-location-arrow"></i>{{ lot.distance.toFixed(1) }} km</div>
                                <div class="parkinglot-distance fr" v-on:click="navigation(lot.latitude, lot.longitude)" v-if="!lot.distance"><i class="fas fa-location-arrow"></i>導航</div>
                                <div class="cb"></div>
                            
                                
                                <div class="parkinglot-name">{{ lot.name }}</div>

                                <div class="parkinglot-currentpay"><span>目前收費</span><i class="fas fa-angle-right"></i>30 / 小時</div>
                                <!--<div class="parkinglot-enter"><span>進場方式</span><i class="fas fa-angle-right"></i>車牌辨識</div>-->
                                <div class="parkinglot-addr"><span>車場地址</span><i class="fas fa-angle-right"></i>{{ lot.addr }}</div>
                            
                            </div>
                        </router-link>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div class="swiper-pagination"  slot="pagination"></div>
                </swiper>
            </div>
        </section>
    </div>
</template>

<style>
    footer {
        display: none;
    }

    .parkinglot-section {
        padding-bottom: 0;
    }
</style>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
    name: 'ParkinglotMap',
    components: {
        swiper,
        swiperSlide
    },
    data () {
            
        return {
            windowHeight: "667px",
            position: "",
            lots: [{
                "latitude": 24.7946832,
                "longitude": 120.9643865,
                "position": {
                    "lat": 24.7946832,
                    "lng": 120.9643865
                },
                "id": "-1",
                "name": "",
                "addr": ""
            }],
            currentIndex: 0,
            loading: true,
            swiperOption: {

            }
        }
    },
    computed: {
        swiper() {
            return this.$refs.lotsSwiper.swiper
        },
    },
    methods: {
        getActiveIndex: (swiper) =>{
            return swiper.activeIndex
        },
        navigation: function(lat, lng) {
            if (this.position.length)
                window.location.replace("http://maps.google.com/maps?saddr=" + this.position.coords.latitude + "," + this.position.coords.longitude + "&daddr=" + lat + "," + lng)
            else
                window.location.replace("https://www.google.pl/maps/place/" + lat + "," + lng + "/@" + lat + "," + lng + ",13z")
        },
        getLots: function() {
            var self = this
            self.loading = false
            self.$http.get('https://' + process.env.VUE_APP_API_URL + '/lots?brand=' + process.env.VUE_APP_BRAND)
            .then((response) => {
                 if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function(position) {
                        self.position = position
                        for(var i = 0; i < response.body.length; i ++) {
                            response.body[i].distance = calcCrow(position.coords.latitude, position.coords.longitude, response.body[i].latitude, response.body[i].longitude)
                        }
                        self.loading = false
                        self.lots = sortByKey(response.body, 'distance')
                    }, function(error) {
                        self.loading = false
                        self.lots = response.body
                    },{
                        timeout: 2000
                    });
                } else {
                    self.loading = false
                    self.lots = response.body
                }
            })
            .catch((response) => {
                console.log("取得資料失敗")
                self.$router.push({ name: 'member_center' })
            })
            .finally(() => {
            });
        },
    },
    watch: {
        swiperOption: function(value) {
        }
    },
    updated: function () {
        var self = this
        if (this.swiperOption.slidesPerView){
            this.swiper.on('slideChangeTransitionEnd', () => {
                self.currentIndex = self.swiper.activeIndex
            })
        }
    },
    mounted() {
        var self = this
        self.getLots()
        self.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        //self.windowHeight -= 61

        if (navigator.userAgent.indexOf("Mobile") < 0) {
            self.swiperOption = {
                slidesPerView: 3,
            }
        } else {
             self.swiperOption = {
                slidesPerView: 1,
            }
        }
    }
}

function calcCrow(lat1, lon1, lat2, lon2) {
  var R = 6371; // km
  var dLat = toRad(lat2-lat1);
  var dLon = toRad(lon2-lon1);
  var lat1 = toRad(lat1);
  var lat2 = toRad(lat2);

  var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c;
  return d;
}
function toRad(Value) {
    return Value * Math.PI / 180;
}

function sortByKey(array, key) {
    return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}

</script>
